import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export interface PlanReviewRequestArgs {
    customerID?: number;
    projectID?: number;
    officeID?: number;
    unitID?: number;
    jobsite?: number;
    assignedTo?: any;
    status?: number;
    address?: string;
    planReviwTaskID?: number;
    includeCompleted?: boolean;
    roleID?: number;
    roleCode?: string;
    moduleCode?: string;
}

const getPlanReviewWithFilters = (filter: PlanReviewRequestArgs) => {
    const {
        customerID,
        officeID,
        projectID,
        unitID,
        jobsite,
        assignedTo,
        status,
        address,
        planReviwTaskID,
        includeCompleted,
        roleID,
        roleCode,
        moduleCode
    } = filter;

    let queryString = '';

    if (customerID) {
        queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
    }
    if (officeID) {
        queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
    }
    if (projectID) {
        queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
    }
    if (unitID) {
        queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
    }
    if (jobsite) {
        queryString += `${queryString ? '&' : ''}Jobsite=${jobsite}`;
    }
    if (assignedTo) {
        queryString += `${queryString ? '&' : ''}AssignedTo=${assignedTo}`;
    }
    if (status) {
        queryString += `${queryString ? '&' : ''}TaskStatusID=${status}`;
    }
    if (address) {
        queryString += `${queryString ? '&' : ''}LotAddress=${address}`;
    }
    if (planReviwTaskID) {
        queryString += `${queryString ? '&' : ''}PlanReviewTaskID=${planReviwTaskID}`;
    }
    if (includeCompleted) {
        queryString += `${queryString ? '&' : ''}IncludeCompleted=${includeCompleted}`;
    }
    if (roleID) {
        queryString += `${queryString ? '&' : ''}RoleID=${roleID}`;
    }
    if (roleCode) {
        queryString += `${queryString ? '&' : ''}RoleCode=${roleCode}`;
    }
    if (moduleCode) {
        queryString += `${queryString ? '&' : ''}DashBoardCode=${moduleCode}`;
    }
    return queryString;
};

export const planReviewApiKeyStore = {
    getPlanReviewDashboards: (args: PlanReviewRequestArgs): QueryKeyConfig => ({
        queryKey: [
            `GET_WORKORDER_REPORTS`,
            [
                args.customerID,
                args.officeID,
                args.projectID,
                args.unitID,
                args.jobsite,
                args.assignedTo,
                args.status,
                args.address,
                args.roleID,
                args.roleCode,
                args.includeCompleted,
                args.moduleCode
            ].filter((a) => a),
        ],
        route: `/PlanReview?${getPlanReviewWithFilters(args)}`,
    }),
    getPlanReviewTask: (planReviewTaskID: any): QueryKeyConfig => ({
        queryKey: [`GET_PLANS_REVIEW_TASK`, planReviewTaskID],
        route: `/PlanReview/Task/${planReviewTaskID}`,
        isEnabled: !!planReviewTaskID && planReviewTaskID > 0,
    }),
    getPlanReviewStatus: (taskCode: string, planReviewTaskID: any): QueryKeyConfig => ({
        queryKey: [`GET_PLAN_REVIEW_TASK_STATUS`, taskCode, planReviewTaskID],
        route: `/PlanReview/Status/${taskCode}/PlanReviewTaskID/${planReviewTaskID}`,
        isEnabled: !!taskCode && !!planReviewTaskID && planReviewTaskID > 0,
    }),
    updatePlanReviewTaskStatus: (): MutationKeyConfig => ({
        mutationKey: [`UPDATE_PLAN_REVIEW_TASK_STATUS`],
        route: `/PlanReview/UpdatePlanReviewTaskStatus`,
        action: 'POST',
    }),
    updatePlanReviewTask: (): MutationKeyConfig => ({
        mutationKey: [`UPDATE_PLAN_REVIEW_TASK`],
        route: `/PlanReview/Task`,
        action: 'PUT',
    }),
    getPlanTaskAssigned: (args: PlanReviewRequestArgs): QueryKeyConfig => ({
        queryKey: [`GET_PLAN_TASK_ASSIGNED`,
            [
                args.planReviwTaskID,
                args.officeID,
                args.moduleCode
            ].filter((a) => a),
        ],
        route: `/PlanReview/Task/Assignees?${getPlanReviewWithFilters(args)}`,
        isEnabled: !!args.moduleCode && ((!!args.planReviwTaskID && args.planReviwTaskID > 0) || (!!args.officeID && args.officeID > 0))
    }),
    assignedPlanTask: (): MutationKeyConfig => ({
        mutationKey: [`ASSIGNED_PLAN_TASK`],
        route: `/PlanReview/Task/Assign`,
        action: 'POST',
    }),
    deletePlanReviewTask: (id: number): MutationKeyConfig => ({
        mutationKey: [`DELETE_PLAN_REVIEW_TASK`, id],
        route: `/PlanReview/DeletePlanReviewTask?planReviewTaskID=${id}`,
        action: 'DELETE',
    }),
    getPlanReviewFilterStatus: (taskCode: string): QueryKeyConfig => ({
        queryKey: [`GET_PLAN_REVIEW_FILTER_STATUS`],
        route: `/PlanReview/Status/Filter/${taskCode}`,
    }),
    getEmailLogs: (planReviewTaskID: number): QueryKeyConfig => ({
        queryKey: [`GET_EMAIL_LOGS`, planReviewTaskID],
        route: `/PlanReview/Task/Emaillog?planReviewTaskID=${planReviewTaskID}`,
        isEnabled: !!planReviewTaskID
    }),
    combinedPDFDownload: (): MutationKeyConfig => ({
        mutationKey: [`COMBINED_PDF_DOWNLOAD`],
        route: `/PlanReview/PlanReviewCombinedPDFDownload`,
        action: 'POST',
    }),
    getPlanReviewDashboardRole: (): QueryKeyConfig => ({
        queryKey: [`GET_PLAN_REVIEW_DASHBOARD_ROLE`],
        route: `/PlanReview/GetPlanReviewDashboardRole`,
    }),
    savePlanReviewDashboardRole: (): MutationKeyConfig => ({
        mutationKey: [`SAVE_PLAN_REVIEW_DASHBOARD_ROLE`],
        route: `/PlanReview/SavePlanReviewDashboardRole`,
        action: 'POST',
    }),
    updateMarkPlanReviewForReReview: (): MutationKeyConfig => ({
        mutationKey: [`UPDATE_MARK_PLAN_REVIEW_FOR_RE_REVIEW`],
        route: `/PlanReview/MarkPlanReviewForReReview`,
        action: 'PUT',
    }),
}